
import {
  Edit,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput
} from "react-admin";
import { LocalizedDateField } from "../../components/localized-date-field.component";
import { JsonInput } from "react-admin-json-view";
import { Col, Row } from "../../components/grid.component";

export const LogsEdit = (props: any) => {
  return (
    <Edit {...props}>
      <SimpleForm>
        <Row spacing={4}>
          <Col sm={3}>
            <ReferenceInput label="Usuário" reference="users" source="userId">
              <SelectInput optionText="name" fullWidth disabled />
            </ReferenceInput>
          </Col>
          <Col sm={3}>
            <TextInput source="level" label="Level" fullWidth disabled />
          </Col>
          <Col sm={3}>
            {/* Display as read-only audit field. Timestamps cannot be edited */}
            <LocalizedDateField
              label="Criado em"
              source="timestamp"
              showTime={true}
            />
          </Col>
          <Col sm={3}>
            <SelectInput
              source="status"
              choices={[
                { id: 0, name: "Aberto" },
                { id: 1, name: "Resolvido" },
              ]}
              fullWidth
            />
          </Col>
        </Row>

        <Row spacing={1}>
          <Col sm={12}>
            <TextInput
              source="message"
              label="Mensagem"
              fullWidth
              disabled
              multiline
              rows={6}
            />
          </Col>
        </Row>
        <Row spacing={1}>
          <Col sm={12}>
            <JsonInput
              source="stack"
              jsonString={false}
              reactJsonOptions={{
                // Props passed to react-json-view
                name: null,
                collapsed: false,
                enableClipboard: false,
                displayDataTypes: false,
              }}
            />
          </Col>
        </Row>
      </SimpleForm>
    </Edit>
  );
};
